module.exports = __webpack_public_path__ + "img/logo-aayi-redondo.c82303ce.png";